import React from 'react';
import { Card } from 'primereact/card';

const DownloadLink = ({ type, href, children }) => {
	const iconClass = type === 'zip' ? 'pi pi-download' : 'pi pi-link';
	const iconColor = type === 'zip' ? 'turquoise' : 'turquoise';

	return (
		<div className="d-flex align-items-start">
			<i className={iconClass} style={{ fontSize: '1em', color: iconColor, marginTop: '0.2rem' }} />
			<a className="ms-2" href={href} target="_blank" rel="noreferrer">
				{children}
			</a>
		</div>
	);
};

const AllDownloadsContent = () => {
	return (
		<div className="grid">
			<div className="col-12 md:col-6">
				<Card title="Client downloads" className="h-100">
					<div className="d-flex flex-column gap-2">
						<DownloadLink type="zip" href="https://download.smarttile.co.uk/installation/client-service/SmartTileClient-latest.zip">
							Latest Version (SmartTileClient)
						</DownloadLink>
						<DownloadLink type="zip" href="https://download.smarttile.co.uk/installation/client-service/SmartTile-1.7.1-RC.zip">
							Release Candidate 1.7.1
						</DownloadLink>
						<DownloadLink
							type="zip"
							href="https://download.smarttile.co.uk/installation/client-service/OPHubAndRelayBarcodeScannerService.zip"
						>
							OP Barcode Scanner for Hub and Relay
						</DownloadLink>
					</div>
				</Card>
			</div>

			<div className="col-12 md:col-6">
				<Card title="Tools" className="h-100">
					<div className="d-flex flex-column gap-2">
						<DownloadLink type="zip" href="https://download.smarttile.co.uk/installation/resources/SmartTile-TestComPorts.zip">
							Test Com Ports
						</DownloadLink>
					</div>
				</Card>
			</div>

			<div className="col-12 md:col-6">
				<Card title="Drivers" className="h-100">
					<div className="d-flex flex-column gap-2">
						<DownloadLink type="zip" href="https://download.smarttile.co.uk/installation/drivers/Prolific_Driver_v408.zip">
							Prolific drivers (Windows 11)
						</DownloadLink>
						<DownloadLink type="zip" href="https://download.smarttile.co.uk/installation/drivers/Prolific_Driver_v402.zip">
							Prolific drivers (Windows 7-10)
						</DownloadLink>
						<DownloadLink type="zip" href="https://download.smarttile.co.uk/installation/drivers/StartechDrivers.zip">
							Startech Drivers
						</DownloadLink>
					</div>
				</Card>
			</div>

			<div className="col-12 md:col-6">
				<Card title="Web apps" className="h-100">
					<div className="d-flex flex-column gap-2">
						<DownloadLink type="link" href="https://keypad.smarttile.co.uk/">
							Keypad
						</DownloadLink>
						<DownloadLink type="link" href="https://hotelkeypad.smarttile.co.uk/">
							Hotel Keypad
						</DownloadLink>
						<DownloadLink type="link" href="https://opengate.smarttile.co.uk/">
							Open gate web
						</DownloadLink>
						<DownloadLink type="link" href="https://reception.smarttile.co.uk/">
							Reception AP
						</DownloadLink>
						<DownloadLink type="link" href="https://accesspodapp.smarttile.co.uk/">
							Access Pod app
						</DownloadLink>
					</div>
				</Card>
			</div>
		</div>
	);
};

export default AllDownloadsContent;
